// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1n88C","upload":"Small_upload__3y7Ee","imageWrap":"Small_imageWrap__5UB--","removeBtn":"Small_removeBtn__3SYTc"};